import React from 'react';

export const PrimaryButton = (props) => (
	<button 
		className={props.className}
		id={props.id}
		onClick={(e) => {
			e.stopPropagation();
			e.preventDefault();
			props.handleClick(props.options)
		}} 
		disabled={props.disabled || false} >
		{props.label}
	</button>
);


// WEBPACK FOOTER //
// ./src/components/BasicForm/PrimaryButton.js